import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useComposeAddress() {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const ComposeAddress = (
    { guid, type, arrow, decreaseType, labelType, isMixed },
    refreshData,
  ) => {
    setLoading(true);
    axiosClient
      .post('/InventoryAddress/Composse', {
        guid,
        type,
        arrow,
        decreaseType,
        labelType,
        isMixed,
      })
      .then(res => {
        if (res.status === 200) {
          const data = {
            ...res.data.value,
            children: [],
          };
          refreshData(data);
          enqueueSnackbar(res.data?.message, { variant: 'success' });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, ComposeAddress];
}
